<template>
  <v-card>
    <v-card-title>Relatório de Comissão</v-card-title>
    <v-card-text>
      <v-list
        height="805"
        :class="listVendas.length == 0 ? 'd-flex flex-column justify-center' : 'overflow-y-auto'"
      >
        <p
          v-if="listVendas.length == 0"
          class="font-weight-normal subtitle-1 text-center"
        >Não há dados para serem apresentados</p>
        <v-list-item v-for="(item, index) in listVendas" :key="index">
          <v-card width="100%" class="pa-4 mb-4">
            <v-card-subtitle class="pa-0 font-weight-medium red--text">{{ item.titulo }}</v-card-subtitle>
            <v-row>
              <v-col cols="12" md="8" lg="8" class="d-flex flex-column py-0">
                <span class="body-1 font-weight-medium">{{ item.veiculo }}</span>
                <span>{{ item.valor | BrazilianCurrency }}</span>
              </v-col>
              <v-col cols="12" md="4" lg="4" class="d-flex flex-column align-end py-0">
                <v-card-subtitle class="pa-0 font-weight-medium red--text">Comissão</v-card-subtitle>
                <span class="font-weight-medium">{{ item.comissao | BrazilianCurrency }}</span>
                <span>{{ item.dataVenda | BrazilianStandardDate}}</span>
              </v-col>
            </v-row>
          </v-card>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import dateMixin from "@/mixins/dateMixin";
import currencyMixin from "@/mixins/currencyMixin";
export default {
  mixins: [dateMixin, currencyMixin],

  data() {
    return {
      listVendas: [],
      venda: ["novos", "usados", "p1", "p2"],
      title: [
        "Venda de Novos",
        "Venda de Usados",
        "Consórcio 1ª Parcela",
        "Consórcio 2ª Parcela"
      ]
    };
  },

  computed: {
    ...mapGetters("relatorios", ["getRelatorios"])
  },

  watch: {
    getRelatorios(value) {
      this.listVendas = [];
      this.getVenda(value);
    }
  },

  methods: {
    getVenda(data) {
      this.venda.forEach((element, index) => {
        let vendas = data[element].data;
        vendas.forEach(item => {
          this.listVendas.push({
            titulo: this.title[index],
            veiculo: item.modelo,
            valor: item.valor_liq == null ? item.valor_bem : item.valor_liq,
            comissao:
              parseFloat(item.total_comissao) < 0
                ? item.total_comissao_perdida
                : item.total_comissao,
            dataVenda: new Date(item.data_venda)
          });
        });
      });

      this.listVendas.sort(function(a, b) {
        return b.dataVenda - a.dataVenda;
      });
    }
  }
};
</script>

<style>
.v-list::-webkit-scrollbar-track {
  /* background-color: #0d47a1; */
  background-color: #eb6b6b;
}
.v-list::-webkit-scrollbar {
  width: 4px;
}
.v-list::-webkit-scrollbar-thumb {
  /* background: #75a5ee; */
  background: #680303;
}
</style>